import { AffiliateUser } from 'types/user';

const getUserScheme = (user: AffiliateUser) => user.scheme;

export default getUserScheme;
